import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M7.5 5L12.5 10L7.5 15" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);